module.exports = __webpack_public_path__ + "img/mr_login_bg.jpeg";